import {
  CLIENT_EDITABLE_PLAN_RECORD_KIND,
  sortClientNutritionPlans,
} from "../Firestore/nutrition/nutritionRecords";
import { resolvePendingWorkspaceState } from "./pendingWorkspaceState";

const toTrimmedString = (value) =>
  typeof value === "string" ? value.trim() : "";

export const toPendingWorkspaceTimestampMs = (value) => {
  if (value && typeof value.toMillis === "function") {
    const ms = value.toMillis();
    return Number.isFinite(ms) ? ms : 0;
  }

  if (value instanceof Date) {
    const ms = value.getTime();
    return Number.isFinite(ms) ? ms : 0;
  }

  if (typeof value === "number" && Number.isFinite(value)) {
    return value;
  }

  const seconds = Number(value?.seconds);
  if (Number.isFinite(seconds)) {
    const nanos = Number(value?.nanoseconds);
    const millisFromNanos = Number.isFinite(nanos)
      ? Math.floor(nanos / 1e6)
      : 0;
    return seconds * 1000 + millisFromNanos;
  }

  return 0;
};

export function normalizePendingWorkspaceBlockRecord(blockDocId, blockData = {}) {
  const blockId = toTrimmedString(blockData?.id) || toTrimmedString(blockDocId);
  if (!blockId) {
    return null;
  }

  return {
    ...blockData,
    id: blockId,
  };
}

export function normalizePendingWorkspaceNutritionPlanRecord(
  planDocId,
  planData = {},
) {
  const normalizedRecordKind = toTrimmedString(planData?.record_kind);
  if (
    normalizedRecordKind &&
    normalizedRecordKind !== CLIENT_EDITABLE_PLAN_RECORD_KIND
  ) {
    return null;
  }

  const planId = toTrimmedString(planData?.id) || toTrimmedString(planDocId);
  if (!planId) {
    return null;
  }

  return {
    ...planData,
    id: planId,
  };
}

export function buildPendingWorkspaceSummary({
  workspaceDocId,
  workspaceData = {},
  blocks = [],
  nutritionPlans = [],
  fallbackIndex = 0,
} = {}) {
  const workspaceState = resolvePendingWorkspaceState(workspaceData);
  const trimmedWorkspaceDocId = toTrimmedString(workspaceDocId);
  const pendingUserId =
    toTrimmedString(workspaceData?.pending_user_id) || trimmedWorkspaceDocId;

  return {
    pendingUserId,
    invitationId: toTrimmedString(workspaceData?.invitation_id),
    invitationEmail: toTrimmedString(workspaceData?.invitation_email),
    isChecked: workspaceState.isChecked,
    weekWorkouts: workspaceState.weekWorkouts,
    lastUpdateMs: toPendingWorkspaceTimestampMs(workspaceData?.last_update),
    blocksCount: Array.isArray(blocks) ? blocks.length : 0,
    blocks: Array.isArray(blocks) ? blocks : [],
    nutritionPlansCount: Array.isArray(nutritionPlans) ? nutritionPlans.length : 0,
    nutritionPlans: sortClientNutritionPlans(
      Array.isArray(nutritionPlans) ? nutritionPlans : [],
    ),
    fallbackIndex,
  };
}

export function sortPendingWorkspaceSummaries(workspaceSummaries = []) {
  return [...(Array.isArray(workspaceSummaries) ? workspaceSummaries : [])].sort(
    (left, right) => {
      if (left?.lastUpdateMs !== right?.lastUpdateMs) {
        return Number(right?.lastUpdateMs ?? 0) - Number(left?.lastUpdateMs ?? 0);
      }

      return Number(left?.fallbackIndex ?? 0) - Number(right?.fallbackIndex ?? 0);
    },
  );
}
